import React from 'react';
import {
  VictoryChart,
  VictoryBar,
  VictoryAxis,
  VictoryTheme,
} from 'victory';
import moment from 'moment';

import {Views} from '../Services/DashboardService';

interface ViewChartProps {
  title: string;
  data: Views[];
}

function ViewChart({title, data}: ViewChartProps) {
  const getPeriodValues = (views: Views[]): Date[] => {
    return views.map(v => v.period);
  };

  const getPeriodLabels = (views: Views[]): string[] => {
    return views.map(v => moment(v.period).format('MMM YY'));
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title text-center">{title}</h5>
        <VictoryChart domainPadding={20} theme={VictoryTheme.material}>
          <VictoryAxis
            tickValues={getPeriodValues(data)}
            tickFormat={getPeriodLabels(data)}
          />
          <VictoryAxis dependentAxis />
          <VictoryBar
            data={data}
            x="period"
            y="count"
          />
        </VictoryChart>
      </div>
    </div>
  );
}

export default ViewChart;
